@if (canRegister()) {
  <button
    bv-button
    variant="primary"
    [size]="size"
    type="button"
    [disabled]="clubServ.loadingID === tournament.tournID || isAtMaxPlayers()"
    (click)="registerTournament(); $event.stopPropagation()"
    id="btn_registerTourn"
    >
    {{ "REGISTER" | translate }}
  </button>
}
@if (canUnregister()) {
  <button
    bv-button
    variant="secondary"
    [size]="size"
    type="button"
    [disabled]="clubServ.loadingID === tournament.tournID"
    (click)="unregisterTournament(); $event.stopPropagation()"
    id="btn_unregisterTourn"
    >
    {{ "UNREGISTER" | translate }}
  </button>
}
